import { render } from "./vue-drag-resize.html?vue&type=template&id=2672fcb3"
import script from "./vue-drag-resize.js?vue&type=script&lang=js"
export * from "./vue-drag-resize.js?vue&type=script&lang=js"

import "./vue-drag-resize.css?vue&type=style&index=0&lang=css"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__